import clsx from "clsx";

import styles from "./StatusPopup.module.scss";
import { Button } from "../Button";

interface StatusPopupProps {
  popupRef?: React.RefObject<HTMLDivElement>;
  customClass?: string;
  title?: string;
  mode: "loading" | "error";
  errorMessage: string | null;
  onRetry?: () => void;
}

const StatusPopup: React.FC<StatusPopupProps> = ({
  popupRef,
  errorMessage,
  title,
  customClass,
  mode,
  onRetry,
}) => {
  return (
    <div className={styles.overlay} role="dialog" aria-modal="true">
      <div
        ref={popupRef}
        className={clsx("form-frame", styles.popup, customClass)}
      >
        {title && <h2 className={styles.title}>{title}</h2>}
        {mode === "loading" ? (
          <div className={styles.fountainGList}>
            <div className={clsx(styles.fountainG, styles.fountainG_1)}></div>
            <div className={clsx(styles.fountainG, styles.fountainG_2)}></div>
            <div className={clsx(styles.fountainG, styles.fountainG_3)}></div>
            <div className={clsx(styles.fountainG, styles.fountainG_4)}></div>
            <div className={clsx(styles.fountainG, styles.fountainG_5)}></div>
            <div className={clsx(styles.fountainG, styles.fountainG_6)}></div>
            <div className={clsx(styles.fountainG, styles.fountainG_7)}></div>
            <div className={clsx(styles.fountainG, styles.fountainG_8)}></div>
          </div>
        ) : (
          <>
            {errorMessage && (
              <p className={styles.errorMessage}>{errorMessage}</p>
            )}
            {onRetry && (
              <Button onClick={onRetry} className={styles.retryBtn}>
                Повторить
              </Button>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default StatusPopup;
